export default __webpack_public_path__ + "static/media/38.d1e9d039.png";